import { render, staticRenderFns } from "./AuthenticatedLayout.vue?vue&type=template&id=8830f028&scoped=true"
import script from "./AuthenticatedLayout.vue?vue&type=script&lang=js"
export * from "./AuthenticatedLayout.vue?vue&type=script&lang=js"
import style0 from "./AuthenticatedLayout.vue?vue&type=style&index=0&id=8830f028&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8830f028",
  null
  
)

export default component.exports